module.exports = __webpack_public_path__ + "img/1.a193947e.png";